import { RouteRecordRaw } from 'vue-router';
import type { RouteLocationNormalized } from 'vue-router';

import { RouteKeys } from '~/router/routes.domain';

export const ActivationRoute: RouteRecordRaw = {
	name: RouteKeys.ACTIVATION,
	path: '/activation',
	alias: '',
	components: {
		default: () => import('~/_v3/activation/ui/pages/ActivationPage.vue')
	},
	meta: {
		public: true
	}
};

export const ActivateRedirectRoute: RouteRecordRaw = {
	name: RouteKeys.ACTIVATE,
	path: '/activate',
	redirect: '/activation',
	meta: {
		public: true
	}
};

export const ActivationFranceConnectRoute: RouteRecordRaw = {
	name: RouteKeys.ACTIVATION_FRANCE_CONNECT,
	path: '/activation/france-connect',
	alias: '',
	components: {
		default: () => import('~/_v3/activation/ui/pages/ActivationWithFranceConnectPage.vue')
	},
	props: {
		default: (route: RouteLocationNormalized) => ({
			sub: route.query.sub as string,
			email: route.query.email as string
		})
	},
	meta: {
		public: true
	}
};

export const ActivationMergeRoute: RouteRecordRaw = {
	name: RouteKeys.ACTIVATION_MERGE,
	path: '/activation/merge-with-france-connect',
	components: {
		default: () => import('~/_v3/activation/ui/pages/ActivationPage.vue')
	},
	props: {
		default: {
			initialState: 'getting_info_for_merge_on_server',
			initialContext: {
				merging: {
					isMergingAccount: true,
					accountToMerge: {
						firstName: '',
						lastName: '',
						activatedAt: '',
						nbDocs: 0
					}
				}
			}
		}
	},
	meta: {
		public: true
	}
};
